import { useEffect, useState } from "react";
import { Telescope, Table2, Mail } from "lucide-react";
import { api } from "@/lib/api";
import { FinderSearch } from "@/components/finder/FinderSearch";
import { ProspectsTable } from "@/components/finder/ProspectsTable";
import { OutreachSettings } from "@/components/finder/OutreachSettings";

const TABS = [["find", "Find shows", Telescope], ["prospects", "Prospects", Table2], ["outreach", "Outreach & schedule", Mail]];

export default function PodcastFinderAdmin() {
  useEffect(() => { document.title = "Podcast Finder — Underdog CMS"; }, []);
  const [tab, setTab] = useState("find");
  const [refreshKey, setRefreshKey] = useState(0);
  const [maxRatings, setMaxRatings] = useState(null);
  useEffect(() => { api.get("/admin/podcast-finder/settings").then((r) => setMaxRatings(r.data.max_ratings)).catch(() => {}); }, [tab]);
  const bump = () => setRefreshKey((k) => k + 1);
  return (
    <div data-testid="admin-podcast-finder">
      <div className="mb-8">
        <p className="eyebrow mb-2">Growth</p>
        <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight">Podcast Finder</h1>
        <p className="mt-2 text-sm text-slate-400 max-w-2xl">Finds independent shows worth recruiting, reads their public feed for a contact, and emails them your pitch — on a Monday/Thursday schedule once you're happy with it.</p>
      </div>
      <div className="mb-6 flex flex-wrap gap-2" data-testid="finder-tabs">
        {TABS.map(([key, label, Icon]) => <button key={key} type="button" onClick={() => setTab(key)} className={`inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-semibold ${tab === key ? "bg-sky-400 text-[#070F1E]" : "bg-white/5 text-slate-300 hover:bg-white/10"}`} data-testid={`finder-main-tab-${key}`}><Icon size={15} /> {label}</button>)}
      </div>
      {tab === "find" && <div className="space-y-6"><FinderSearch onDone={bump} /><ProspectsTable refreshKey={refreshKey} maxRatings={maxRatings} /></div>}
      {tab === "prospects" && <ProspectsTable refreshKey={refreshKey} maxRatings={maxRatings} />}
      {tab === "outreach" && <OutreachSettings onRun={bump} />}
    </div>
  );
}
